var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "capa-1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 372.6",
    style: {
      enableBackground: "new 0 0 500 372.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E0E0E0;}\n\t.st1{fill:#EFEFEF;}\n\t.st2{fill:#F4F4F4;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:#EBEBEB;}\n\t.st5{opacity:0.5;fill:#F4F4F4;enable-background:new    ;}\n\t.st6{fill:#F5F5F5;}\n\t.st7{fill:#1A2E35;}\n\t.st8{fill:#3F91D9;}\n\t.st9{opacity:0.3;enable-background:new    ;}\n\t.st10{fill:#FD897B;}\n\t.st11{fill:#E77064;}\n\t.st12{fill:#FD5652;}\n\t.st13{fill:#F9F9F9;}\n\t.st14{opacity:0.1;fill:#FFFFFF;enable-background:new    ;}\n\t.st15{opacity:0.3;fill:#FFFFFF;enable-background:new    ;}\n\t.st16{opacity:0.8;fill:#FFFFFF;enable-background:new    ;}\n\t.st17{opacity:0.8;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-80"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 327.4,
    className: "st0",
    width: 500,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.3,
    y: 340.5,
    className: "st0",
    width: 28.4,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.6,
    y: 340.6,
    className: "st0",
    width: 25.4,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.5,
    y: 334.8,
    className: "st0",
    width: 34.1,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.6,
    y: 342.5,
    className: "st0",
    width: 47.5,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.9,
    y: 334.5,
    className: "st0",
    width: 45.9,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.4,
    y: 334.5,
    className: "st0",
    width: 15.6,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.5,
    y: 339,
    className: "st0",
    width: 40.2,
    height: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M237,282.8H43.9c-3.1,0-5.7-2.6-5.7-5.7V5.7c0-3.1,2.6-5.7,5.7-5.7H237c3.2,0,5.7,2.6,5.7,5.7c0,0,0,0,0,0l0,0 v271.4C242.7,280.2,240.2,282.8,237,282.8z M43.9,0.2c-3,0-5.5,2.4-5.5,5.5v271.4c0,3,2.4,5.5,5.5,5.5H237c3,0,5.4-2.4,5.5-5.5V5.7 c0-3-2.4-5.4-5.5-5.5H43.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M453.3,282.8H260.2c-3.1,0-5.7-2.6-5.7-5.7V5.7c0-3.1,2.6-5.7,5.7-5.7h193.1c3.1,0,5.7,2.5,5.7,5.7v271.4 C459,280.2,456.5,282.8,453.3,282.8L453.3,282.8z M260.2,0.2c-3,0-5.4,2.4-5.5,5.5v271.4c0,3,2.4,5.4,5.5,5.5h193.1 c3,0,5.4-2.4,5.5-5.5V5.7c0-3-2.4-5.4-5.5-5.5H260.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.4,
    y: 24.3,
    className: "st0",
    width: 257,
    height: 129.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.7,
    y: 24.3,
    className: "st1",
    width: 257,
    height: 129.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.7,
    y: 30.3,
    className: "st2",
    width: 245,
    height: 117.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "98.9,147.8 165.3,30.4 196.4,30.4 130,147.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "140.5,147.8 206.9,30.4 238,30.4 171.6,147.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "227,147.8 293.4,30.4 306.2,30.4 239.8,147.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.9,
    y: 30.3,
    className: "st0",
    width: 9.1,
    height: 117.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.8,
    y: 30.3,
    className: "st0",
    width: 9.1,
    height: 117.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.1,
    y: 25.8,
    className: "st2",
    width: 9.1,
    height: 125.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157,
    y: 25.8,
    className: "st2",
    width: 9.1,
    height: 125.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.2,
    y: 30.3,
    className: "st0",
    width: 2.5,
    height: 117.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M391.8,192.1c0,0-18.3-31.6,7.1-56.8c0,0,6.6,4.3,6.5,10.1s-7.1,7.3-5.6,12.1s8.1,9.6,3.8,13.6 s0.7,7.6,0.4,12.5S391.8,192.1,391.8,192.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M394.7,197.2c0,0,7.4-35.8-24.6-51.6c0,0-4.9,6.2-3,11.7s9,4.7,9.1,9.8s-4.7,11.7,0.7,14.1s1.7,7.4,3.6,12 S394.7,197.2,394.7,197.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M378.4,188.2c0,0,0.3,14.9,12.7,14.9s12.7-14.9,12.7-14.9H378.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M292.8,191.5c0,0,0.4,11.6,16.6,11.6s16.7-11.6,16.7-11.6H292.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M330.4,194.3c0,0,0.3,8.7,12.5,8.7s12.5-8.7,12.5-8.7H330.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.9,
    y: 210.3,
    className: "st4",
    width: 27.3,
    height: 109.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.1,
    y: 319.9,
    className: "st4",
    width: 134.7,
    height: 7.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.2,
    y: 210.3,
    className: "st2",
    width: 117.9,
    height: 109.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.9,
    y: 220.9,
    className: "st4",
    width: 96.4,
    height: 38.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.9,
    y: 266.9,
    className: "st4",
    width: 96.4,
    height: 38.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M374,225.2h-21.7c-1.5,0-2.7-1.2-2.7-2.7l0,0c0-1.5,1.2-2.7,2.7-2.7H374c1.5,0,2.7,1.2,2.7,2.7l0,0 C376.7,224,375.5,225.2,374,225.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M374,271.1h-21.7c-1.5,0-2.7-1.2-2.7-2.7l0,0c0-1.5,1.2-2.7,2.7-2.7H374c1.5,0,2.7,1.2,2.7,2.7l0,0 C376.7,269.9,375.5,271.1,374,271.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.2,
    y: 203.1,
    className: "st4",
    width: 121.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273,
    y: 203.1,
    className: "st0",
    width: 31.1,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.4,
    y: 42.5,
    className: "st4",
    width: 59.2,
    height: 68.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.2,
    y: 42.5,
    className: "st2",
    width: 64.1,
    height: 68.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.6,
    y: 47.9,
    className: "st3",
    width: 53.4,
    height: 57.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M385.2,61.8h18.1c2.6,0,4.7,2.1,4.7,4.7v20.2c0,2.6-2.1,4.7-4.7,4.7h-18.1c-2.6,0-4.7-2.1-4.7-4.7V66.5 C380.5,63.9,382.6,61.8,385.2,61.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.2,
    y: 263.9,
    className: "st0",
    width: 6.9,
    height: 63.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.6,
    y: 263.9,
    className: "st5",
    width: 3.4,
    height: 63.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M239,281.7h-4.7c1-0.9,1.7-2.2,1.6-3.6H180c0,1.4,0.6,2.7,1.7,3.6H177c-3.5,0-6.3,2.8-6.3,6.3v18.4 c0,3.5,2.8,6.3,6.3,6.3h62c3.5,0,6.3-2.8,6.3-6.3V288C245.3,284.5,242.5,281.7,239,281.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M149.7,295.3h37.6c2.3,0,4.2,1.9,4.2,4.2v8.9c0,2.3-1.9,4.2-4.2,4.2h-37.6c-2.3,0-4.2-1.9-4.2-4.2v-8.9 C145.4,297.2,147.3,295.3,149.7,295.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M146.8,291.4h43.2c0.8,0,1.4,0.6,1.4,1.4v1.6c0,0.8-0.6,1.4-1.4,1.4h-43.2c-0.8,0-1.4-0.6-1.4-1.4v-1.6 C145.4,292.1,146.1,291.4,146.8,291.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M195.8,235.6c0,0,0.6,21,25.2,21s25.2-21,25.2-21H195.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.1,
    y: 256.6,
    className: "st0",
    width: 30.7,
    height: 7.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.8,
    y: 256.6,
    className: "st2",
    width: 185.1,
    height: 7.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.1,
    y: 312.7,
    className: "st0",
    width: 30.7,
    height: 7.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.1,
    y: 263.9,
    className: "st0",
    width: 6.9,
    height: 63.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.6,
    y: 263.9,
    className: "st5",
    width: 3.4,
    height: 63.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.4,
    y: 263.9,
    className: "st2",
    width: 6.9,
    height: 63.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.4,
    y: 263.9,
    className: "st0",
    width: 3.4,
    height: 63.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 263.9,
    className: "st2",
    width: 6.9,
    height: 63.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 263.9,
    className: "st0",
    width: 3.4,
    height: 63.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.8,
    y: 312.7,
    className: "st2",
    width: 185.1,
    height: 7.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.8,
    y: 252.2,
    className: "st0",
    width: 37.3,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.2,
    y: 252.2,
    className: "st4",
    width: 13.4,
    height: 4.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-80"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st6",
    cx: 250,
    cy: 361.2,
    rx: 193.9,
    ry: 11.3
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-80"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M217.9,95.7c0.1,11.8-8.4,11.7-8.2,8s-1.9-12.5,0-11.6S217.8,90.5,217.9,95.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M212.5,117.2c1.2-0.1,3.5,1,3.7,4.1c0.1,1.8,1.1,3.5,2.6,4.5c0,0-3.9,0.5-6.4-1.6c-2.1-1.6-3-5.2-1.9-6 C211.1,117.7,211.8,117.4,212.5,117.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M211,108.7c2,1.8,3.8,6.4-0.7,8.7s-11.6-3-11.6-3l7.8-3.6L211,108.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M213.2,117.6c-0.1-0.6-0.3-1.3-0.5-1.9c-0.1-0.2-0.3-0.3-0.5-0.2c0,0,0,0,0,0h-0.1l-2.8,1.8 c-0.2,0.1-0.2,0.4-0.1,0.6c0,0,0,0,0,0l0,0c0,0,0.1,0.1,0.1,0.1c0.4,0.3,0.8,0.5,1.3,0.7c0.6,0.3,2-0.5,2.5-0.8 C213.2,117.9,213.2,117.7,213.2,117.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M213.2,117.6c-0.1-0.6-0.3-1.3-0.5-1.9c-0.1-0.2-0.3-0.3-0.5-0.2c0,0,0,0,0,0h-0.1l-2.8,1.8 c-0.2,0.1-0.2,0.4-0.1,0.6c0,0,0,0,0,0l0,0c0,0,0.1,0.1,0.1,0.1c0.4,0.3,0.8,0.5,1.3,0.7c0.6,0.3,2-0.5,2.5-0.8 C213.2,117.9,213.2,117.7,213.2,117.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M183.4,112.7c-1.1-0.4-3.6,0.1-4.6,3.1c-0.5,1.7-1.9,3.1-3.6,3.8c0,0,3.7,1.4,6.6,0c2.4-1.1,4.1-4.3,3.3-5.4 C184.7,113.5,184.1,113,183.4,112.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M194.4,92.3c-4.1,1.1-9.5,5.9-7.1,11.8c-2.4,1.6-5.4,6.3-1.9,9.3c3.9,3.2,13.3-1.3,13.3-1.3l0.1-1.5l1.1-11.5 L194.4,92.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M182.6,112.9c0.3-0.6,0.6-1.2,1-1.7c0.1-0.2,0.4-0.2,0.6-0.1l0.1,0.1l2.2,2.4c0.2,0.2,0.2,0.4,0,0.6 c0,0,0,0,0,0l0,0c0,0-0.1,0.1-0.1,0.1c-0.5,0.2-0.9,0.3-1.4,0.4c-0.7,0.1-1.8-0.9-2.2-1.3C182.7,113.3,182.6,113.1,182.6,112.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M182.6,112.9c0.3-0.6,0.6-1.2,1-1.7c0.1-0.2,0.4-0.2,0.6-0.1l0.1,0.1l2.2,2.4c0.2,0.2,0.2,0.4,0,0.6 c0,0,0,0,0,0l0,0c0,0-0.1,0.1-0.1,0.1c-0.5,0.2-0.9,0.3-1.4,0.4c-0.7,0.1-1.8-0.9-2.2-1.3C182.7,113.3,182.6,113.1,182.6,112.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M219.1,134.1c1.9,1.5,4,3.1,6.1,4.5s4.2,2.9,6.4,4.2s4.4,2.6,6.6,3.8l1.7,0.9l1.7,0.8 c0.6,0.3,1.1,0.5,1.7,0.7l0.9,0.4c0.3,0.1,0.6,0.2,0.8,0.3c1,0.3,2.1,0.5,3.2,0.7c1.2,0.2,2.4,0.3,3.7,0.4c2.5,0.2,5.1,0.2,7.7,0.2 s5.2,0,7.8-0.1l7.9-0.2l0.5,3.9c-5.3,1.1-10.6,1.8-15.9,2.4c-2.7,0.2-5.4,0.4-8.1,0.4c-1.4,0-2.8,0-4.2-0.1 c-1.5-0.1-3.1-0.3-4.6-0.8c-0.5-0.1-0.8-0.2-1.1-0.4l-1-0.4c-0.7-0.2-1.3-0.5-2-0.7l-1.9-0.8l-1.9-0.8c-2.5-1.1-5-2.4-7.3-3.8 c-2.4-1.4-4.7-2.8-6.9-4.4c-2.3-1.5-4.5-3.2-6.6-5L219.1,134.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M208.7,129.6c2.5-1.9,12.7,4.4,15.9,7.1l-2.3,13.7c0,0-14.8-6.2-15.6-10.4 C205.7,135.6,206.8,131.1,208.7,129.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M274,150.9l6.2-4.8l0.5,7.4c0,0-4.3,2.6-7.1,1L274,150.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "285.7,145.4 288.9,148.9 280.6,153.5 280.1,146.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "168.3,351.5 176.1,352 178.9,334.1 171.1,333.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "113.2,326.4 119.8,330.6 131.6,316.6 124.9,312.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M121.9,329.1l-6.2-6.2c-0.2-0.2-0.6-0.2-0.8-0.1l-5.6,4.2c-0.5,0.4-0.6,1.2-0.2,1.8l0.1,0.1 c2.2,2.1,3.4,3,6.1,5.8c1.7,1.7,3.9,4.3,6.2,6.6s4.7,0.2,4-1c-3.4-5.3-2.8-7.2-3-9.9C122.4,329.9,122.2,329.4,121.9,329.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M176.6,350.9h-8.8c-0.3,0-0.6,0.2-0.6,0.5l-1.4,6.9c-0.1,0.6,0.3,1.2,0.9,1.4l0,0c0.1,0,0.2,0,0.3,0 c3.1,0,4.6-0.2,8.4-0.2c2.4,0,9,0.2,12.3,0.2s3.6-3.2,2.3-3.5c-6-1.3-10.1-3.1-12.1-4.9C177.5,351.1,177.1,350.9,176.6,350.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "178.9,334.1 177.3,344.1 169.6,342.8 171.1,333.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "124.9,312.5 131.6,316.6 126.7,322.4 119.9,318.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M174.2,171.1l31.1,6.1c16.1-43.6,12.6-45,12.6-45c-2.3-1.2-4.6-2.3-7-3.3l-0.4-0.2c-2-0.7-2.4-0.8-5.1-1.6 c-4.6-1.1-8.9-2-14.1-2.8l-1-0.1c-1-0.1-1.9-0.2-2.8-0.3c-0.6-0.1-1.2-0.1-1.8-0.2l-2-0.1c-3.4-0.2-5.9-0.1-5.9-0.1 C178.7,150.8,177.2,158.6,174.2,171.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M195.8,108.7c0,4.7-0.7,13.2-4.5,15.7c0,0,0.4,4.9,8.8,6.5c9.3,1.8,5.3-3.8,5.3-3.8c-4.8-2.2-4-5.9-2.4-9.3 L195.8,108.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M198.8,112.4l4.3,5.4c-0.4,0.8-0.7,1.6-0.9,2.4c-1.9-0.7-4.1-3.3-4-5.4C198.2,114,198.4,113.2,198.8,112.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M195.4,97.9c-1,7.7-1.6,10.9,1.5,15.6c4.6,7,14.3,6.6,17.6-0.7c3-6.5,4.1-18-2.7-22.5 c-4.9-3.2-11.4-1.9-14.6,3c0,0,0,0,0,0l0,0C196.1,94.7,195.6,96.3,195.4,97.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M220.4,85.7c0.1,1.2,0,2.5-0.3,3.6c-0.1-0.4-0.2-0.8-0.3-1.2c-2.7-9.1-15.1-6.9-18.8-3c-6-1.7-11.7-0.3-10.9,7 c0.1,1.9,0.8,3.7,1.9,5.2c-0.9,2.6,0,6.7,3.1,6.8c4.3,0.2,8.4-5.6,10.1-8.7c3,0.5,7.3,1,10.6,0.2c0.6,0.3,1,0.6,1,0.6 C220.3,94.4,222.9,92.6,220.4,85.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M192.7,103.2c-0.1,1.5,0.4,3,1.3,4.1c1.3,1.5,3,0.6,3.6-1.2c0.5-1.6,0.4-4.3-1.3-5.2 c-1.3-0.6-2.8-0.1-3.4,1.2c0,0,0,0,0,0l0,0C192.8,102.4,192.7,102.8,192.7,103.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M204.9,177.2c0,0,0.1,61.8-4.9,85.1c-5.3,24.2-20.7,79.3-20.7,79.3l-11.2-1.4c0,0,8.8-55.7,12.5-79.7 c4.1-26.2,1.6-87.7,1.6-87.7L204.9,177.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M204.9,177.2c0,0,0.1,61.8-4.9,85.1c-5.3,24.2-20.7,79.3-20.7,79.3l-11.2-1.4c0,0,8.8-55.7,12.5-79.7 c4.1-26.2,1.6-87.7,1.6-87.7L204.9,177.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "181.1,342.6 166.1,340.6 166.7,335.3 183.8,337.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M197.1,175.6c0,0-16.8,51.1-25.1,80.5c-8.8,31-42.4,65.4-42.4,65.4l-9.7-5.6c0,0,23-32.6,31.5-61.6 c17.2-58.8,10.1-71.3,22.8-83.2L197.1,175.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M197.1,175.6c0,0-16.8,51.1-25.1,80.5c-8.8,31-42.4,65.4-42.4,65.4l-9.7-5.6c0,0,23-32.6,31.5-61.6 c17.2-58.8,10.1-71.3,22.8-83.2L197.1,175.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "131.1,323.1 117.7,315.3 121.1,310.5 136,318.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M206.5,102.3c-0.1,0.6,0.1,1.2,0.5,1.3s0.8-0.4,1-1s-0.1-1.2-0.5-1.3S206.6,101.7,206.5,102.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M213.4,103.6c-0.1,0.6,0.1,1.2,0.5,1.3s0.8-0.4,0.9-1s-0.1-1.2-0.5-1.3S213.6,103,213.4,103.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M214.2,102.7l1.6-0.1C215.8,102.5,214.8,103.5,214.2,102.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M211.4,104.3c0.3,1.5,0.8,3,1.4,4.4c-0.7,0.3-1.6,0.3-2.3,0L211.4,104.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M207.9,110.7L207.9,110.7c-1.7-0.3-3.1-1.4-3.9-2.9c0-0.1,0-0.2,0.1-0.2c0,0,0,0,0,0l0,0c0.1,0,0.2,0,0.2,0.1 c0.7,1.4,2.1,2.4,3.6,2.7c0.1,0,0.2,0.1,0.2,0.2c0,0,0,0,0,0l0,0C208.1,110.7,208,110.7,207.9,110.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M204.9,99.6c-0.2,0-0.4-0.2-0.4-0.4c0-0.1,0-0.2,0.1-0.3c0.9-0.8,2.1-1.2,3.2-0.9c0.2,0.1,0.3,0.3,0.3,0.5 c0,0.2-0.2,0.3-0.4,0.3c0,0,0,0,0,0l0,0c-0.9-0.2-1.9,0.1-2.6,0.8C205.1,99.6,205,99.6,204.9,99.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M217.3,101c-0.2,0-0.3-0.1-0.3-0.2c-0.4-0.9-1.1-1.5-2-1.8c-0.2,0-0.3-0.2-0.3-0.4c0,0,0,0,0,0l0,0 c0-0.2,0.2-0.3,0.4-0.3c1.2,0.3,2.1,1.1,2.5,2.2c0.1,0.2,0,0.4-0.2,0.5c0,0,0,0,0,0l0,0L217.3,101z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M207.3,107.8c-0.6,0-1.2-0.3-1.6-0.8c-1-1.5-1.2-3.3-0.8-5c0.6-3.2,2.6-5.7,4.4-5.7c0.6,0,1.2,0.3,1.6,0.8 c1,1.5,1.2,3.3,0.8,5C211.2,105.2,209.2,107.8,207.3,107.8z M209.3,96.5c-1.8,0-3.6,2.5-4.2,5.5c-0.4,2-0.1,3.8,0.8,4.8 c0.3,0.4,0.9,0.7,1.4,0.7c1.8,0,3.6-2.5,4.2-5.5l0,0c0.4-1.6,0.2-3.4-0.8-4.8C210.4,96.8,209.9,96.5,209.3,96.5L209.3,96.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M215.1,108.8L215.1,108.8c-0.7,0-1.3-0.3-1.7-0.8c-0.9-1.4-1.2-3-0.8-4.6c0.5-2.9,2.4-5.3,4.3-5.3l0,0 c0.7,0,1.3,0.3,1.7,0.8c0.9,1.4,1.2,3,0.8,4.6l0,0C218.9,106.4,216.9,108.8,215.1,108.8z M216.8,98.2c-1.7,0-3.5,2.3-4,5.1 c-0.4,1.5-0.1,3.1,0.8,4.4c0.4,0.5,0.9,0.7,1.5,0.8l0,0c1.7,0,3.6-2.3,4-5.1l0,0c0.4-1.5,0.1-3.1-0.8-4.4 C218,98.5,217.4,98.2,216.8,98.2L216.8,98.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M124.2,332.7L124.2,332.7c-1,0-2-1.5-2.6-2.4c0-0.1,0-0.1,0-0.2c0-0.1,0.1-0.1,0.2-0.1 c0.3,0.1,3.1,0.7,3.4,1.6c0.1,0.2,0,0.4-0.1,0.6C124.9,332.5,124.5,332.7,124.2,332.7z M122.1,330.5c0.8,1.2,1.5,1.9,2.1,1.9 c0.2,0,0.5-0.1,0.6-0.3c0.1-0.1,0.1-0.2,0.1-0.3C124.6,331.2,123.2,330.7,122.1,330.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M122.5,330.5c-0.3,0-0.6,0-0.9-0.1c-0.1,0-0.1-0.1-0.1-0.1c0-0.1,0-0.1,0-0.2c0.1-0.1,1.6-1.6,2.7-1.6h0.1 c0.3,0,0.5,0.2,0.7,0.4c0.2,0.2,0.2,0.6,0.1,0.8C124.8,330.2,123.5,330.5,122.5,330.5z M122.1,330.1c0.9,0.1,2.5-0.2,2.8-0.6 c0.1-0.1,0.1-0.2-0.1-0.4c-0.1-0.1-0.3-0.2-0.5-0.2C123.5,329,122.7,329.4,122.1,330.1L122.1,330.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M179.5,352.3c-0.8,0-1.7-0.1-2.5-0.3c-0.1,0-0.1-0.1-0.1-0.2c0-0.1,0-0.2,0.1-0.2c0.4-0.2,3.6-1.8,4.5-1.2 c0.2,0.1,0.3,0.3,0.3,0.5c0,0.3-0.1,0.7-0.4,0.9C180.8,352.2,180.1,352.3,179.5,352.3z M177.6,351.8c1.7,0.3,3,0.2,3.5-0.2 c0.2-0.1,0.3-0.4,0.2-0.6c0-0.1,0-0.1-0.1-0.2C180.8,350.5,179,351.1,177.6,351.8L177.6,351.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M177.1,352h-0.1c-0.1,0-0.1-0.1-0.1-0.2c0-0.1,0.5-3.3,2.2-3.3h0.1c0.5,0,0.6,0.3,0.7,0.5 C180,349.9,178.1,351.6,177.1,352L177.1,352z M179.1,348.8c-1.1,0-1.6,1.8-1.8,2.6c1-0.6,2.3-1.9,2.2-2.5 C179.5,349,179.5,348.9,179.1,348.8L179.1,348.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M207.2,101.3l1.6-0.1C208.8,101.2,207.8,102.2,207.2,101.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M200.4,137.5c-13-4.9-17.1-12.3-16.8-13.9l0,0l2,0.1h0.4c0.5,0,1,0.1,1.5,0.1c0.9,0.1,1.9,0.2,2.8,0.3l1,0.1 c4.8,0.6,9.5,1.5,14.1,2.8c2.1,0.6,2.8,0.8,4,1.2l1,0.4l0.4,0.2C211.9,131.1,211.7,135.7,200.4,137.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M200.4,137.5c-13-4.9-17.1-12.3-16.8-13.9l0,0l2,0.1h0.4c2.6,3.8,8.4,8.9,14.3,9.6c4.7-1,9.2-2.1,9.2-5.1 l1,0.4l0.4,0.2C211.9,131.1,211.7,135.7,200.4,137.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M200.4,137.5c-13-4.9-17.1-12.3-16.8-13.9l0,0l2,0.1h0.4c2.6,3.8,8.4,8.9,14.3,9.6c4.7-1,9.2-2.1,9.2-5.1 l1,0.4l0.4,0.2C211.9,131.1,211.7,135.7,200.4,137.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M174.1,169.2l-2,2.5c-0.1,0.2,0.1,0.5,0.4,0.5l32.7,6.4c0.3,0.1,0.5,0,0.6-0.2l0.8-2.7 c0.1-0.2-0.1-0.4-0.5-0.5l-31.5-6.1C174.4,169,174.2,169.1,174.1,169.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M177.6,173.6l-0.8-0.2c-0.2,0-0.3-0.1-0.2-0.2l1.1-3.5c0-0.1,0.2-0.2,0.4-0.1l0.9,0.2c0.2,0,0.3,0.1,0.2,0.2 l-1.1,3.6C177.9,173.6,177.8,173.6,177.6,173.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M177.6,173.6l-0.8-0.2c-0.2,0-0.3-0.1-0.2-0.2l1.1-3.5c0-0.1,0.2-0.2,0.4-0.1l0.9,0.2c0.2,0,0.3,0.1,0.2,0.2 l-1.1,3.6C177.9,173.6,177.8,173.6,177.6,173.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M179.9,135.6c-0.4,2.4-0.7,5-1,7.5s-0.5,5-0.6,7.6c-0.1,1.3-0.1,2.5-0.1,3.8v3.8c0,2.4,0.2,4.9,0.6,7.3 c0.2,0.8,0.5,1.6,1,2.3c0.6,1,1.3,1.9,2,2.8c1.6,1.9,3.3,3.7,5.1,5.4c1.8,1.8,3.8,3.5,5.7,5.1s4,3.3,6,4.9l-2.1,3.3 c-4.7-2.6-9.2-5.5-13.5-8.8c-2.2-1.7-4.3-3.5-6.2-5.5c-1-1.1-2-2.2-2.8-3.4c-1.1-1.4-1.8-3.1-2.2-4.8l-0.4-2.1 c-0.1-0.7-0.2-1.4-0.3-2.1c-0.2-1.4-0.3-2.8-0.4-4.1c-0.2-2.7-0.3-5.5-0.2-8.2c0.1-2.7,0.2-5.4,0.5-8.1s0.6-5.3,1.1-8.1 L179.9,135.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M173.2,125.6c-4.3,3.5-3.3,13.7-3.3,13.7l14.4,4.7c0,0-0.7-11.9-1.4-16.1C182.1,122.9,177.4,122.2,173.2,125.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M196.8,185.4l6.5-2.4l-1,6.2c0,0-4.7,1.7-7.1-0.5L196.8,185.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "211,183.9 211,188.6 202.3,189.1 203.3,182.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M202.8,178.5l-0.8-0.2c-0.2,0-0.3-0.1-0.2-0.2l1.1-3.5c0-0.1,0.2-0.2,0.4-0.1l0.8,0.2c0.2,0,0.3,0.1,0.2,0.2 l-1.1,3.6C203.1,178.4,203,178.5,202.8,178.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M202.8,178.5l-0.8-0.2c-0.2,0-0.3-0.1-0.2-0.2l1.1-3.5c0-0.1,0.2-0.2,0.4-0.1l0.8,0.2c0.2,0,0.3,0.1,0.2,0.2 l-1.1,3.6C203.1,178.4,203,178.5,202.8,178.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M190.2,176l-0.9-0.2c-0.2,0-0.3-0.1-0.2-0.2l1.1-3.5c0-0.1,0.2-0.2,0.4-0.1l0.9,0.2c0.2,0,0.3,0.1,0.2,0.2 l-1.1,3.6C190.6,176,190.4,176.1,190.2,176z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M190.2,176l-0.9-0.2c-0.2,0-0.3-0.1-0.2-0.2l1.1-3.5c0-0.1,0.2-0.2,0.4-0.1l0.9,0.2c0.2,0,0.3,0.1,0.2,0.2 l-1.1,3.6C190.6,176,190.4,176.1,190.2,176z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M126.5,234.3l51.8,113.2c2.5,5.4,8.8,7.7,14.2,5.3l8.2-3.8l190.6-87.2c5.4-2.5,7.7-8.8,5.3-14.2l-45.8-100 l-6-13.2c-2.5-5.3-8.8-7.7-14.2-5.3l-198.8,91C126.5,222.6,124.1,228.9,126.5,234.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M126.5,234.3l51.8,113.2c2.5,5.4,8.8,7.7,14.2,5.3l8.2-3.8l190.6-87.2c5.4-2.5,7.7-8.8,5.3-14.2l-45.8-100 l-6-13.2c-2.5-5.3-8.8-7.7-14.2-5.3l-198.8,91C126.5,222.6,124.1,228.9,126.5,234.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.5,
    y: 227.5,
    transform: "matrix(0.9092 -0.4163 0.4163 0.9092 -83.0215 135.6101)",
    className: "st8",
    width: 240,
    height: 61.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.5,
    y: 227.5,
    transform: "matrix(0.9092 -0.4163 0.4163 0.9092 -83.0215 135.6101)",
    className: "st15",
    width: 240,
    height: 61.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.6,
    y: 236.7,
    transform: "matrix(0.9092 -0.4163 0.4163 0.9092 -76.5732 144.2022)",
    className: "st8",
    width: 151.7,
    height: 22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.6,
    y: 236.7,
    transform: "matrix(0.9092 -0.4163 0.4163 0.9092 -76.5732 144.2022)",
    className: "st16",
    width: 151.7,
    height: 22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.7,
    y: 208.9,
    transform: "matrix(0.9079 -0.4191 0.4191 0.9079 -70.8636 128.052)",
    className: "st8",
    width: 240.6,
    height: 32.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.7,
    y: 208.9,
    transform: "matrix(0.9079 -0.4191 0.4191 0.9079 -70.8636 128.052)",
    className: "st9",
    width: 240.6,
    height: 32.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M156.2,235.7L200.8,349l190.6-87.2c5.4-2.5,7.7-8.8,5.3-14.2l-45.8-100l-188.6,74.3 C156.7,224,154,230.2,156.2,235.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.2,
    y: 200,
    transform: "matrix(0.9435 -0.3315 0.3315 0.9435 -43.9562 146.9305)",
    className: "st8",
    width: 1,
    height: 4.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.2,
    y: 200,
    transform: "matrix(0.9435 -0.3315 0.3315 0.9435 -43.9562 146.9305)",
    className: "st14",
    width: 1,
    height: 4.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.6,
    y: 177.2,
    transform: "matrix(0.9435 -0.3313 0.3313 0.9435 -39.0263 144.1099)",
    className: "st8",
    width: 1,
    height: 18.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.6,
    y: 177.2,
    transform: "matrix(0.9435 -0.3313 0.3313 0.9435 -39.0263 144.1099)",
    className: "st14",
    width: 1,
    height: 18.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M169.4,222.2l206.3-72.4c5.6-1.9,11.7,1,13.6,6.6l41.3,117.5c1.9,5.6-1,11.7-6.5,13.6l-206.3,72.4 c-5.6,1.9-11.7-1-13.6-6.5l-41.3-117.5C161,230.3,163.9,224.2,169.4,222.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M169.4,222.2l206.3-72.4c5.6-1.9,11.7,1,13.6,6.6l41.3,117.5c1.9,5.6-1,11.7-6.5,13.6l-206.3,72.4 c-5.6,1.9-11.7-1-13.6-6.5l-41.3-117.5C161,230.3,163.9,224.2,169.4,222.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.9,
    y: 239.5,
    transform: "matrix(0.9435 -0.3313 0.3313 0.9435 -71.3487 114.7608)",
    className: "st8",
    width: 240,
    height: 54.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.9,
    y: 239.5,
    transform: "matrix(0.9435 -0.3313 0.3313 0.9435 -71.3487 114.7608)",
    className: "st15",
    width: 240,
    height: 54.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.1,
    y: 184.4,
    transform: "matrix(0.9435 -0.3313 0.3313 0.9435 -42.287 128.569)",
    className: "st8",
    width: 49.6,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.1,
    y: 184.4,
    transform: "matrix(0.9435 -0.3313 0.3313 0.9435 -42.287 128.569)",
    className: "st16",
    width: 49.6,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.4,
    y: 272.2,
    transform: "matrix(0.9435 -0.3313 0.3313 0.9435 -68.7665 145.148)",
    className: "st8",
    width: 39.8,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.4,
    y: 272.2,
    transform: "matrix(0.9435 -0.3313 0.3313 0.9435 -68.7665 145.148)",
    className: "st16",
    width: 39.8,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.8,
    y: 281.4,
    transform: "matrix(0.9435 -0.3313 0.3313 0.9435 -71.9754 144.718)",
    className: "st8",
    width: 51.3,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.8,
    y: 281.4,
    transform: "matrix(0.9435 -0.3313 0.3313 0.9435 -71.9754 144.718)",
    className: "st16",
    width: 51.3,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.9,
    y: 332.7,
    transform: "matrix(0.9435 -0.3313 0.3313 0.9435 -98.7655 94.8276)",
    className: "st8",
    width: 25.6,
    height: 8.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.9,
    y: 332.7,
    transform: "matrix(0.9435 -0.3313 0.3313 0.9435 -98.7655 94.8276)",
    className: "st16",
    width: 25.6,
    height: 8.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M368.8,258.5l28.3-9.9c3.1-1.1,4.7-4.5,3.7-7.6l0,0c-1.1-3.1-4.5-4.7-7.6-3.7l-28.3,9.9 c-3.1,1.1-4.7,4.5-3.7,7.6l0,0C362.3,258,365.7,259.6,368.8,258.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M320.4,275.5l28.3-9.9c3.1-1.1,4.7-4.5,3.6-7.6l0,0c-1.1-3.1-4.5-4.7-7.6-3.6l-28.3,9.9 c-3.1,1.1-4.7,4.5-3.7,7.6l0,0C313.9,275,317.3,276.6,320.4,275.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M272,292.5l28.3-9.9c3.1-1.1,4.7-4.5,3.6-7.6l0,0c-1.1-3.1-4.5-4.7-7.6-3.6l-28.3,9.9 c-3.1,1.1-4.7,4.5-3.6,7.6l0,0C265.5,292,268.9,293.6,272,292.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M223.6,309.5l28.3-9.9c3.1-1.1,4.7-4.5,3.7-7.6l0,0c-1.1-3.1-4.5-4.7-7.6-3.6l-28.3,9.9 c-3.1,1.1-4.7,4.5-3.7,7.6l0,0C217.1,309,220.5,310.6,223.6,309.5z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M368.8,258.5l28.3-9.9c3.1-1.1,4.7-4.5,3.7-7.6l0,0c-1.1-3.1-4.5-4.7-7.6-3.7l-28.3,9.9 c-3.1,1.1-4.7,4.5-3.7,7.6l0,0C362.3,258,365.7,259.6,368.8,258.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M320.4,275.5l28.3-9.9c3.1-1.1,4.7-4.5,3.6-7.6l0,0c-1.1-3.1-4.5-4.7-7.6-3.6l-28.3,9.9 c-3.1,1.1-4.7,4.5-3.7,7.6l0,0C313.9,275,317.3,276.6,320.4,275.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M272,292.5l28.3-9.9c3.1-1.1,4.7-4.5,3.6-7.6l0,0c-1.1-3.1-4.5-4.7-7.6-3.6l-28.3,9.9 c-3.1,1.1-4.7,4.5-3.6,7.6l0,0C265.5,292,268.9,293.6,272,292.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M223.6,309.5l28.3-9.9c3.1-1.1,4.7-4.5,3.7-7.6l0,0c-1.1-3.1-4.5-4.7-7.6-3.6l-28.3,9.9 c-3.1,1.1-4.7,4.5-3.7,7.6l0,0C217.1,309,220.5,310.6,223.6,309.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M358.3,213.1l25.2-8.8c2.1-0.8,4.5,0.4,5.2,2.5l5.2,14.9c0.8,2.1-0.4,4.5-2.5,5.2l-25.2,8.8 c-2.1,0.8-4.5-0.4-5.2-2.5l-5.2-14.9C355.1,216.2,356.2,213.8,358.3,213.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M358.3,213.1l25.2-8.8c2.1-0.8,4.5,0.4,5.2,2.5l5.2,14.9c0.8,2.1-0.4,4.5-2.5,5.2l-25.2,8.8 c-2.1,0.8-4.5-0.4-5.2-2.5l-5.2-14.9C355.1,216.2,356.2,213.8,358.3,213.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M231.7,232c-2.6-7.5-10.9-11.5-18.4-8.9c0,0,0,0,0,0l0,0l-20.3,7.6l-0.3,0.1l-0.6,0.2l-0.4,0.1l0,0 c-7,3.2-10.2,11.5-7,18.5c3,6.6,10.5,9.8,17.3,7.5l19.2-6.4c0.6-0.1,1.1-0.3,1.6-0.5c0.4-0.1,0.8-0.3,1.2-0.5l0,0 C230.8,246.8,234.1,239,231.7,232z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M231.7,232c-2.6-7.5-10.9-11.5-18.4-8.9c0,0,0,0,0,0l0,0l-20.3,7.6l-0.3,0.1l-0.6,0.2l-0.4,0.1l0,0 c-7,3.2-10.2,11.5-7,18.5c3,6.6,10.5,9.8,17.3,7.5l19.2-6.4c0.6-0.1,1.1-0.3,1.6-0.5c0.4-0.1,0.8-0.3,1.2-0.5l0,0 C230.8,246.8,234.1,239,231.7,232z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/creditCard.dab1f9ae674d750fad63dbcfcff140d3.svg";
export { ForwardRef as ReactComponent };